/**
 * /plateau-progression — Progression pédagogique plateau moto A1/A2 (P1/P2/P3).
 * Référentiel enseignant complet : 17 compétences × 12 champs pédagogiques.
 */
import React from 'react';
import TrameProgression from '../components/trames/TrameProgression';
import TrameLivretCross from '../components/trames/TrameLivretCross';
import { INTRO_METHODOLOGIE, PHASES, DEMI_TOUR, buildSynthese } from '../data/plateauProgression';

export default function PlateauProgression() {
  return (
    <>
      <TrameLivretCross
        current="trame"
        trameTo="/plateau-progression"
        trameLabel="Trame pédagogique Plateau A1/A2"
        livretTo="/livret-plateau"
        livretLabel="Livret Plateau interactif à cocher"
      />
      <TrameProgression
        testid="plateau-progression"
        trameKey="plateau"
        title="Apprendre le plateau moto — A1 / A2"
        subtitle="Progression pédagogique en 3 phases (P1 · P2 · P3) de la découverte à l’autonomie. Chaque compétence est présentée comme une fiche exploitable en salle, sur le plateau ou en circulation."
        badge="Trame pédagogique plateau A1 / A2"
        breadcrumbLabel="Plateau A1 / A2 · P1 P2 P3"
        intro={INTRO_METHODOLOGIE}
        phases={PHASES}
        buildSynthese={buildSynthese}
        focusBlock={{ ...DEMI_TOUR, visibleOn: ['p2', 'p3'] }}
      />
    </>
  );
}
